/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import _ from 'lodash';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import PanToolIcon from '@material-ui/icons/PanTool';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import './styles.css';


export default ({
  modelFieldsOrderedAndMerged, isSubmitting, onCheck, removeChild,
}) => (
  <Droppable droppableId="droppableAreaLevel1" type="droppableArea" isCombineEnabled>
    {(provided, snapshot) => (
      <div
        ref={provided.innerRef}
        className="droppable"
        style={{
            backgroundColor: snapshot.isDraggingOver ? '#E6EEF6' : '#FAFCFD',
            padding: 8,
        }}
        {...provided.droppableProps}
      >
        {modelFieldsOrderedAndMerged.map(({ fields, order }) => (
          <Draggable
            draggableId={`draggableEntryLevel1_${order}`}
            key={`draggableEntryLevel1_${order}`}
            index={order}
          >
            {(draggableProvided, draggableSnapshot) => (
              <div
                ref={draggableProvided.innerRef}
                {...draggableProvided.draggableProps}
              >
                <div style={{ paddingBottom: 16 }}>
                  <span
                    style={{
                        backgroundColor: '#0255A3',
                        padding: '6px 6px 4px 4px',
                        borderRadius: 4,
                        display: 'block',
                        width: 12,
                        zIndex: 100,
                        position: 'relative',
                    }}
                    {...draggableProvided.dragHandleProps}
                  >
                    <PanToolIcon style={{ width: 12, height: 12, color: '#FAFCFD' }} />
                  </span>
                  <div
                    className="droppable"
                    style={{
                        backgroundColor: draggableSnapshot.isDragging ? '#CCDDED' : '#FFFFFF',
                        width: 'calc(100% - 8px)',
                        position: 'relative',
                        marginTop: -16,
                        marginLeft: 8,
                    }}
                  >
                    <div style={{ paddingLeft: 8, paddingRight: 8 }}>
                      {fields.length === 1 && (
                        <FormControlLabel
                          key={`${_.snakeCase(fields[0].field)}_checkbox`}
                          control={
                            <Checkbox
                              name={_.snakeCase(fields[0].field)}
                              value={fields[0].field}
                              checked={fields[0].isSelected}
                              disabled={isSubmitting}
                              onChange={() => onCheck(order, fields[0].order)}
                            />}
                          label={fields[0].field}
                        />
                        )}
                      {fields.length > 1 && (
                      <Droppable droppableId="droppableAreaLevel2" type="droppableArea2" isCombineEnabled>
                        {droppableProvider => (
                          <div
                            ref={droppableProvider.innerRef}
                            {...droppableProvider.droppableProps}
                          >
                            {fields.map(fieldEntry => (
                              <Draggable
                                draggableId={`draggableEntryLevel2_${fieldEntry.order}_Level1_${order}`}
                                key={`draggableEntryLevel2_${fieldEntry.order}_Level1_${order}`}
                                index={fieldEntry.order}
                              >
                                {(draggableProvidedLevel2, draggableSnapshotLevel2) => (
                                  <div
                                    ref={draggableProvidedLevel2.innerRef}
                                    {...draggableProvidedLevel2.draggableProps}
                                  >
                                    <div style={{ paddingBottom: 16 }}>
                                      <div style={{
                                        zIndex: 100,
                                        position: 'relative',
                                      }}
                                      >
                                        <span
                                          style={{
                                                    backgroundColor: '#0255A3',
                                                    padding: '6px 6px 4px 4px',
                                                    borderRadius: 4,
                                                    display: 'inline-block',
                                                    width: 12,
                                                }}
                                          {...draggableProvidedLevel2.dragHandleProps}
                                        >
                                          <PanToolIcon style={{ width: 12, height: 12, color: '#FAFCFD' }} />
                                        </span>
                                        <span
                                          style={{
                                                    backgroundColor: '#F5222D',
                                                    padding: '6px 4px 4px 4px',
                                                    borderRadius: 4,
                                                    display: 'inline-block',
                                                    width: 12,
                                                    float: 'right',
                                                    cursor: 'pointer',
                                                }}
                                          role="button"
                                          tabIndex={0}
                                          aria-hidden="true"
                                          onClick={() => removeChild(order, fieldEntry.order)}
                                        >
                                          <RemoveCircleIcon style={{ width: 12, height: 12, color: '#FAFCFD' }} />
                                        </span>
                                      </div>
                                      <div
                                        className="droppable"
                                        style={{
                                                    backgroundColor: draggableSnapshotLevel2.isDragging ? '#CCDDED' : '#FFFFFF',
                                                    width: 'calc(100% - 8px)',
                                                    position: 'relative',
                                                    marginTop: -16,
                                                    marginLeft: 8,
                                                    paddingLeft: 8,
                                                    paddingRight: 8,
                                                }}
                                      >
                                        <FormControlLabel
                                          key={`${_.snakeCase(fieldEntry.field)}_checkbox`}
                                          control={
                                            <Checkbox
                                              name={_.snakeCase(fieldEntry.field)}
                                              value={fieldEntry.field}
                                              checked={fieldEntry.isSelected}
                                              disabled={isSubmitting}
                                              onChange={() => onCheck(order, fieldEntry.order)}
                                            />}
                                          label={fieldEntry.field}
                                        />
                                      </div>
                                    </div>
                                  </div>)}
                              </Draggable>
                                    ))}
                            {droppableProvider.placeholder}
                          </div>
                                )}
                      </Droppable>
                      )}
                    </div>
                  </div>
                </div>
              </div>
          )}
          </Draggable>
        ))}
        {provided.placeholder}
      </div>
    )}
  </Droppable>
);



// WEBPACK FOOTER //
// ./src/components/CustomExportButton/DroppableLevel1.jsx